import { apiSlice } from "../../app/api/apiSlice";

export const contractApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getContracts: builder.query({
      query: () => "/contract",
      // keepUnusedDataFor: 5,
      providesTags: (result, error, arg) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "Contract", id: _id })),
              "Contract",
            ]
          : ["Contract"],
    }),
    addNewContract: builder.mutation({
      query: (contract) => ({
        url: "/contract",
        method: "POST",
        body: {
          ...contract,
        },
      }),
      invalidatesTags: ["Contract"],
    }),
    updateContract: builder.mutation({
      query: (data) => ({
        url: "/contract",
        method: "PATCH",
        body: { ...data },
      }),
      invalidatesTags: ["Contract"],
    }),
    deleteContract: builder.mutation({
      query: (data) => ({
        url: "/contract",
        method: "DELETE",
        body: data,
      }),
      invalidatesTags: ["Contract"],
    }),
  }),
});

export const {
  useGetContractsQuery,
  useAddNewContractMutation,
  useUpdateContractMutation,
  useDeleteContractMutation,
} = contractApiSlice;
